import { Component } from '@angular/core';
import { DialogComponent } from 'src/app/pages/common/dialog/dialog.component';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss'],
})
export class ConfirmDialogComponent extends DialogComponent {}
